import { useQuery } from '@tanstack/react-query';
import { progressApi } from './api';

/** `['progress', trackSlug]` — only for signed-in learners. */
export function useProgress(trackSlug: string, enabled = true) {
  return useQuery({
    queryKey: ['progress', trackSlug],
    queryFn: () => progressApi.get(trackSlug),
    staleTime: 30_000,
    enabled,
  });
}
